export interface PostProcessingParams {
  vesselPartitionerRadius: number;
  vesselPartitionerNKeep: number;
}

export const POSTPROCESSING_PARAMS: Readonly<Record<string, PostProcessingParams>> = {
  thickTrunk: { vesselPartitionerRadius: 9, vesselPartitionerNKeep: 120},
  thinTrunk:  { vesselPartitionerRadius: 12, vesselPartitionerNKeep: 180},
}

export type PostProcessingParamsName = keyof typeof POSTPROCESSING_PARAMS
